import { Badge } from "@/components/base/badges/badges";

type Props = {
  sampleApplicationStatus: string | null;
};

/**
 * Maps sample application status to display label for the Sample Status column
 */
const getSampleStatusLabel = (status: string): string => {
  switch (status) {
    case "PENDING":
      return "To Review";
    case "AWAITING_SHIPMENT":
      return "Preparing";
    case "SHIPPED":
      return "In Transit";
    case "CONTENT_PENDING":
      return "Delivered";
    default:
      return "Unknown";
  }
};

/**
 * Maps sample application status to badge color
 */
const getSampleStatusColor = (status: string): "orange" | "blue-light" | "success" | "gray" => {
  switch (status) {
    case "PENDING":
      return "orange";
    case "AWAITING_SHIPMENT":
      return "blue-light";
    case "SHIPPED":
      return "blue-light";
    case "CONTENT_PENDING":
      return "success";
    default:
      return "gray";
  }
};

/**
 * Badge component for displaying sample shipment status.
 * Used in the Sample Status tab to show where the sample is in the shipping process.
 * Renders a dash when there is no application yet (null status).
 */
export const SampleStatusBadge = ({ sampleApplicationStatus }: Props) => {
  if (!sampleApplicationStatus) {
    return <span className="text-sm text-quaternary">--</span>;
  }

  const label = getSampleStatusLabel(sampleApplicationStatus);
  const color = getSampleStatusColor(sampleApplicationStatus);

  return (
    <Badge color={color} size="sm">
      {label}
    </Badge>
  );
};
